exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".tooltipOverrides__icon___2STrC:hover .tooltipOverrides__iconPath___YDZjg{fill:hsla(0,0%,100%,.7)}.tooltipOverrides__iconPath___YDZjg{fill:#fff}.tooltipOverrides__icon___2STrC{margin-left:3px}", ""]);

// exports
exports.locals = {
	"icon": "tooltipOverrides__icon___2STrC",
	"iconPath": "tooltipOverrides__iconPath___YDZjg"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!./~/postcss-loader!./src/client/components/PageCharges/overrides/tooltipOverrides.pcss
// module id = 907
// module chunks = 0